import icon from "./img/testimonials-icon.png";
function Test() {
  return (
    <>
      <section className="gold h-[50vh] flex justify-center items-center">
        <div className="flex flex-col items-center ">
          <img className="mb-[30px] w-[30px]" src={icon} alt="" />
          <h1 className="head text-[3.5rem] mb-[50px] w-[70%] text-center">
            When I was 14, I had a job in cake shop. I got caught by the boss,
            lying down eating cake, and was sacked on ny first day.
          </h1>
          <p>Noel Fielding</p>
        </div>
      </section>
      <section className="video h-[70vh] bg-img flex justify-center items-center">
        <i class="fas fa-play-circle text-[8rem] gold"></i>
      </section>
    </>
  );
}
export { Test };
